import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const appGroupApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAppGroup: builder.query({
      query: ({appGroupId}) => {
        return {
          url: `/app_groups/${appGroupId}`,
        }},
      providesTags: (result = [], error, {appGroupId}) => [{ type: 'AppGroup', id: appGroupId } ],
    }),
    createAppGroup: builder.mutation({
      query: ({publisherId, appGroup}) => {
        return {
          url: `/publishers/${publisherId}/app_groups/`,
          method: 'POST',
          body: appGroup
        }},
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }],
    }),
    updateAppGroup: builder.mutation({
      query: ({appGroupId, appGroup}) => {
        return {
          url: `/app_groups/${appGroupId}/`,
          method: 'PUT',
          body: appGroup
        }},
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {appGroupId}) => [{ type: 'CmpConfig' }, { type: 'AppGroup', id: appGroupId }],
    }),
    deleteAppGroup: builder.mutation({
      query: ({appGroupId}) => {
        return {
          url: `/app_groups/${appGroupId}/`,
          method: 'DELETE',
        }},
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {appGroupId}) => [{ type: 'CmpConfig' }],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetAppGroupQuery,
  useCreateAppGroupMutation,
  useUpdateAppGroupMutation,
  useDeleteAppGroupMutation
} = appGroupApiSlice
